
import { makeStyles } from "tss-react/mui";

/*
* Function to dynamically create styling class from theme object
*/
export function ApplyStyle( themeStyle ) {
  const useStyles = makeStyles()(() => ({
    style: {
      ...themeStyle,
    }
  }));
  const {classes} = useStyles();

  return classes.style;
}
